/**
 * List items have either 1 or 2 children, always in the following order:
 * 0 - list item text
 * 1 - nested list (optional)
 */
export const TEXT_PATH_INDEX = 0;
export const NESTED_LIST_PATH_INDEX = 1;
